<template>
  <div class="wl-header-bar">
    <div class="container">
      <div class="row">
        <div class="col-6">
          <h1 class="d-inline">{{ title }}</h1>
          &nbsp;
          <span v-if="saving"
            ><b-spinner small type="grow"></b-spinner> Saving...
          </span>
          <span v-else-if="uncommitted">Unsaved Changes</span>
          <span v-else-if="subtitle">{{ subtitle }}</span>
        </div>
        <div class="col-6 text-right">
          <span v-if="lastEdited"
            ><small>
              Last edited {{ lastEdited.date | formatDatetime }} by
              {{ lastEdited.name }}
            </small></span
          >
          &nbsp;&nbsp;&nbsp;&nbsp;
          <b-link :to="'/settings/' + slug" v-if="showSettings">
            <svg class="ml-1 bi" fill="currentColor" width="24px" height="24px">
              <use
                xlink:href="/app/themes/jeroboams-2020/node_modules/bootstrap-icons/bootstrap-icons.svg#gear-fill"
              />
            </svg>
          </b-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: [String, Boolean],
      default: false,
    },
    lastEdited: {
      type: [Object, Boolean],
      default: false,
    },
    saving: {
      type: Boolean,
      default: false,
    },
    uncommitted: {
      type: Boolean,
      default: false,
    },
    showSettings: {
      type: Boolean,
      default: false,
    },
    slug: {
      type: String,
      default: "",
    },
  },
};
</script>